import { DOWNLOAD_REPORTS, GET_TRANSACTIONS_LIST } from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const reportsSlice = createCrudSlice({
  name: "reports",
  urls: {},
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {
    getTransactionsList: {
      type: "reports/getTransactionsList",
      url: GET_TRANSACTIONS_LIST,
      method: "post",
      stateKey: "transactions",
    },
    getTransactionsList: {
      type: "reports/getTransactionsList",
      url: GET_TRANSACTIONS_LIST,
      method: "post",
      stateKey: "transactions",
    },
    downloadTransactionsReport: {
      type: "reports/downloadTransactionsReport",
      url: () => `${DOWNLOAD_REPORTS}/transaction`,
      method: "post",
      stateKey: "transactionsExportData",
    },

  },
  initialState: {
    transactions: [],
    transactionsExportData: [],
  },
});

// Export actions
export const { setFilter, resetFilters } = reportsSlice.actions;

// Export thunks
export const { getTransactionsList, downloadTransactionsReport } =
  reportsSlice.thunks;

// Export reducer
export default reportsSlice.reducer;
